<template>
	<div class="row text-left events-tracker">
		<div class="col-sm-6 col-12">
			<div class="element-box relative">
				<h6 class="element-header capitalize">

				</h6>
			<formGenerator v-if="form" :schema="form.schema" :model="form.model" :options="form.options"></formGenerator>
			</div>
		</div>
		<div class="col-sm-6 col-12">
			<div class="element-box relative">
				<h6 class="element-header capitalize">

				</h6>
				<div class="timed-activities compact text-left mt-4">
					<div class="timed-activity">
						<draggable v-model="events" :change="moved($event)" @end="moved">
							<transition-group>
								<div v-for="(e, key) in events" :key="e.order" :id="e.id">
									<template v-if="e.time > 0">
										<div class="ta-record-w">
											<div class="ta-record">
												<div class="ta-timestamp">
													<span class="text-warning">{{ e.time }}'</span>
												</div>
												<div class="ta-activity">
													{{ e.name }}
													<div v-if="e.player">
														({{ e.player }})
													</div>
													<div v-if="e.scorer">
														({{ e.scorer }})
													</div>
													<span v-if="e.team">
														({{ e.team }})
													</span>
													<a href="javascript:;" v-on:click="editThis(e.id)"
													   class="pull-right text-white px-3">
														<i class="os-icon os-icon-pencil-1"></i>
													</a>
													<a href="javascript:;" v-on:click="deleteThis(e.id)"
													   class="pull-right text-danger px-3">
														<i class="os-icon os-icon-ui-15"></i>
													</a>
												</div>
											</div>
											<div class="row">
												<formGenerator v-if="edit == e.id" :schema="form.schema" :model="e" :options="form.options"></formGenerator>
											</div>
										</div>
									</template>

									<template v-if="e.time < 0">
										<div class="ta-date">
											<span>{{ e.name }}</span>
											<a href="javascript:;" v-on:click="editThis(e.id)" class="pull-right text-white px-3"><i class="os-icon os-icon-pencil-1"></i></a>
											<a href="javascript:;" v-on:click="deleteThis(e.id)" class="pull-right text-danger px-3"><i class="os-icon os-icon-ui-15"></i></a>
										</div>
										<div class="row">
											<formGenerator v-if="edit == e.id" :schema="form.schema" :model="e" :options="form.options"></formGenerator>
										</div>
									</template>
								</div>
							</transition-group>
						</draggable>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import draggable from 'vuedraggable'
    import VueFormGenerator from "vue-form-generator";
    import "vue-form-generator/dist/vfg.css";  // optional core css additions
    export default {
        name: "events",
        components: { "formGenerator": VueFormGenerator.component, draggable},
	    props: ['match', 'event'],
        data () {
            return {
                t: this.$root.t,
                events: null,
	              type: null,
                form: null,
                list: null,
	            competitors: [
                    {value: '', name: 'Takim yok'},
                    {value: 'away', name: 'Deplasman'},
		            {value: 'home', name: 'Ev sahibi'},
	            ],
	            edit: 0
            }
        },
	    watch: {
            'event' (){
                this.fetchEvents()
            }
	    },
	    mounted() {
            this.fetchEvents()
            this.fetchEventTypes()
	    },
	    methods: {
            moved(m) {
                this.orderEvent();
            },
            orderEvent() {
                    this.$bus.$emit('globalLoader', true);
                    this.$http.post(bsapi+'api/v1/match/events/order', {events: this.events}).then(response => {

                        this.$bus.$emit('globalLoader', false);
                    }, response => {
                        this.$bus.$emit('globalLoader', false);

                    })
            },
            editThis(e){
                    this.edit = (this.edit === e) ? 0 : e;
            },
            deleteThis(e, index){
                this.$http.delete(bsapi+'api/v1/match/events/delete/'+e, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}}).then(response => {
                    this.fetchEvents()
                }, response => {

                })
            },
            addEvent () {
                this.form = {
                    model: {
                        time: -1,
                        matchId: this.event,
                        team: '',
                        description: 'Started',
                        player: null,
                        scorer: null
                    },
                    schema: {
                        fields: [
                            {
                                type: "choices",
                                label: this.t.competitor,
                                model: "team",
                                multi: false,
                                required: false,
                                multiSelect: false,
                                values: this.competitors,
                                options: {
                                    value: "value",
                                    name: "name"
                                }
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: this.t.player,
	                            placeholder: 'Player name',
                                model: "player",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "input",
                                inputType: "text",
                                label: this.t.scorer,
                                placeholder: 'Scorer name',
                                model: "scorer",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "input",
                                inputType: "number",
                                label: this.t.time,
                                model: "time",
                                readonly: false,
                                featured: false,
                                disabled: false
                            },
                            {
                                type: "choices",
                                label: this.t.event,
                                model: "description",
                                multi: false,
                                required: false,
                                multiSelect: false,
                                values: this.type,
                                options: {
                                    value: "event",
                                    name: "name"
                                }
                            },
                            {
                                type: "submit",
                                label: "",
                                buttonText: this.t.save,
                                onSubmit: this.setEvents,
                                validateBeforeSubmit: false,
                            }
                        ]
                    },
                    options: {
                        validateAfterLoad: true,
                        validateAfterChanged: true
                    }
                }
            },
            fetchEventTypes () {
                this.$http.get(bsapi+'api/v1/match/stat/events/type?sport='+this.match.sport.id).then(response => {

                    this.type = response.body.result;
                    this.addEvent()
                }, response => {

                })
            },
            fetchEvents () {
                this.$bus.$emit('globalLoader', true);
                this.$http.get(bsapi+'api/v1/match/events/'+this.event).then(response => {

                    this.events = response.body.result;
                    this.$bus.$emit('globalLoader', false);

                }, response => {
                    this.$bus.$emit('globalLoader', false);
                })
            },
            setEvents (e) {
                this.edit = 0;
                this.$bus.$emit('globalLoader', true);
                this.$http.post(bsapi+'api/v1/match/event/create', e).then(response => {
                    this.$bus.$emit('globalLoader', false);
                    this.fetchEvents()
                }, response => {
                    this.$bus.$emit('globalLoader', false);
                })
            },
	    }
    }
</script>

<style scoped>
  .events-tracker{
    height: 80vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/stats/match/events.vue